import { PanelAlertIcon } from 'assets/icons';
import addDays from 'date-fns/addDays';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import { t } from 'i18next';
import { FC } from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import AlertInfo from 'shared/components/Alert';
import {
	ACCOUNT_DOCUMENT_STATUS_EXPIRED,
	ACCOUNT_DOCUMENT_STATUS_REJECTED,
	ACCOUNT_DOCUMENT_STATUS_TO_CHECK,
	AWAITING_ADMIN_APPROVAL,
} from 'shared/constants/common';
import { State } from 'shared/interface';

interface Props {
	customerAccountDetails: any;
	customerAccountStatus: any;
}

const PanelVerificationAlerts: FC<Props> = ({ customerAccountDetails, customerAccountStatus }) => {
	const verificationStatus = useSelector<State, string>((state) => state.login.accountDetail?.account?.verificationStatus);
	const isDocumentRejected = ACCOUNT_DOCUMENT_STATUS_REJECTED === verificationStatus;
	const verfiedAccount = customerAccountDetails.accountStatus !== customerAccountStatus.UNVERIFIED_ACCOUNT;
	const verficiationStatusExpired = ACCOUNT_DOCUMENT_STATUS_EXPIRED === verificationStatus;
	const accountAwaitingApproval = AWAITING_ADMIN_APPROVAL === verificationStatus;
	const reVerificationCondition =
		customerAccountDetails.accountStatus === customerAccountStatus.UNVERIFIED_ACCOUNT &&
		[ACCOUNT_DOCUMENT_STATUS_REJECTED, ACCOUNT_DOCUMENT_STATUS_TO_CHECK].includes(verificationStatus);
	const userRegistrationDate = useSelector((state: RootStateOrAny) => state.login.accountDetail.account?.registrationDetails?.regDate);

	const calculateDaysDifference = (startDate: Date) => {
		const currentDate = new Date();
		const endDate = addDays(startDate, 30);

		const differenceInDays = differenceInCalendarDays(endDate, currentDate);
		return differenceInDays;
	};
	const inputDate = new Date(userRegistrationDate);
	const daysLeftToVerifyAcc = calculateDaysDifference(inputDate);
	const hasThirtyDaysPassed = daysLeftToVerifyAcc < 0;

	const alertConditions = [
		{
			conditions: [reVerificationCondition, isDocumentRejected],
			content: {
				title: t('accountVerificationPrompt'),
				description: t('accountReVerificationPrompt'),
				isInformation: true,
				isRedirectionArrow: true,
			},
		},
		{
			conditions: [reVerificationCondition, !isDocumentRejected],
			content: {
				title: hasThirtyDaysPassed
					? t('verifyAccountThirtyDaysAfterReg')
					: t('verifyAccountAfterRegTitle', { numofdays: daysLeftToVerifyAcc }),
				description: t('verifyAccountAfterRegDesc'),
				isError: true,
				isRedirectionArrow: true,
			},
		},
		{
			conditions: [verfiedAccount, verficiationStatusExpired],
			content: {
				title: t('accountExpired'),
				description: t('accountVerificationPromptSubTitle'),
				isError: true,
				isRedirectionArrow: true,
			},
		},

		{
			conditions: [accountAwaitingApproval],
			content: {
				title: t('accountVerificationPrompt'),
				description: t('accountUnderVerificationPrompt'),
				isInformation: true,
				isRedirectionArrow: false,
			},
		},
	];

	const activeAlert = alertConditions.find((alert) => {
		return alert?.conditions?.every((condition) => condition);
	});

	return (
		<>
			{activeAlert && (
				<AlertInfo
					icon={<PanelAlertIcon />}
					title={activeAlert?.content?.title}
					description={activeAlert?.content?.description}
					isInformation={activeAlert?.content?.isInformation}
					isError={activeAlert?.content?.isError}
					isRedirectionArrow={activeAlert?.content?.isRedirectionArrow}
				/>
			)}
		</>
	);
};

export default PanelVerificationAlerts;
